const changeDocumentName = (documentName) => {
    documentName.replaceAll("ЭБСО", "Е-БСО");
    return documentName;
}

export default changeDocumentName;